module.exports = "https://static.energy5.com/_next/static/images/slide02-d77fd2b0d4c0afe4a9039080bef1c287.webp";